import { useCallback, useEffect } from 'react';
import { useBeforeUnload, useBlocker, } from 'react-router-dom';
export const usePrompt = (when) => {
    const blocker = useBlocker(when);
    useEffect(() => {
        if (blocker.state === 'blocked' && !when) {
            blocker.reset();
        }
    }, [blocker, when]);
    useBeforeUnload(useCallback((event) => {
        if (when) {
            event.preventDefault();
            event.returnValue = '';
        }
    }, [when]), { capture: true });
    return blocker;
};
